export default __webpack_public_path__ + "static/media/google.7d34ce0e.svg";